import axios from 'axios';
import { config } from 'config/config';

const createAxiosInstance = (
  baseURL: string,
  apiKey: string,
  clientKey: string
) => {
  const instance = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
      apiKey,
      clientKey,
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return instance;
};

export const userAxiosInstance = createAxiosInstance(
  '',
  '',
  ''
  // config.USER_API_URL || '',
  // config.USER_API_KEY,
  // config.USER_CLIENT_KEY
);
